import Forgot from "../../modules/Auth/components/Forgot.jsx";

function PageForgot() {
    return <><Forgot/></>
}

export default PageForgot;
